import React from 'react'
import Classes from '../ViewReport.module.css'

export default function Hero1({ exposures }) {
    const totalRecords = exposures.length;
    const deletedRecords = exposures.filter(e => e.deletionStatus === 'completed').length;
    const inProgress = exposures.filter(e => e.deletionStatus === 'inProgress').length;
    const brokersWithInfo = new Set(exposures.map(e => e.brokerName)).size;

    return (
        <div className={Classes.hero1}>
            <div className={Classes.heroBox}>
                <h1>{totalRecords}</h1>
                <h5>Data Records Reviewed</h5>
            </div>
            <div className={Classes.miniLine}></div>
            <div className={Classes.heroBox}>
                <h1>{deletedRecords}</h1>
                <h5>Data Records Deleted</h5>
            </div>
            <div className={Classes.miniLine}></div>
            <div className={Classes.heroBox}>
                <h1>{inProgress}</h1>
                <h5>Removal(s) in Progress</h5>
            </div>
            <div className={Classes.miniLine}></div>
            <div className={Classes.heroBox}>
                <h1>{brokersWithInfo}</h1>
                <h5>Data Brokers with your Info</h5>
            </div>
        </div>
    )
}